import { render, staticRenderFns } from "./ProductListCarouselCard.vue?vue&type=template&id=a48848b4&"
import script from "./ProductListCarouselCard.vue?vue&type=script&lang=js&"
export * from "./ProductListCarouselCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports